import type { ReactNode } from 'react';

interface IPageLoaderProps {
    isLoading: boolean;
    error: string | null;
    children: ReactNode;
}

const PageLoader = ({ isLoading, error, children }: IPageLoaderProps) => {
    // BusyOverlay reports the wait, so the page itself stays blank until the model lands.
    if (isLoading) return null;

    return (
        <>
            {error && (
                <div className="row">
                    <div className="col-xs-12">
                        <div className="alert alert-danger">{error}</div>
                    </div>
                </div>
            )}

            {children}
        </>
    );
};

export default PageLoader;
